import * as React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink";
import { UnstructuredFormSection } from "~/components/form";
import { Callout, CalloutType } from "~/primitiveComponents/dataDisplay/Callout";
import { TentacleCalloutHeading } from "./TentacleCalloutHeading";

export const LinuxListeningTentacleCallout: React.SFC<{ thumbprint: React.ReactNode }> = ({ thumbprint }) => (
    <UnstructuredFormSection stretchContent={true}>
        <Callout type={CalloutType.Information} title={"Installation Instructions"}>
            <TentacleCalloutHeading />
            <div>
                <p>
                    For getting started instructions please visit the <ExternalLink href="LinuxListeningTentacle">Linux Tentacle documentation</ExternalLink>.
                </p>
                {thumbprint}
            </div>
        </Callout>
    </UnstructuredFormSection>
);

export default LinuxListeningTentacleCallout;
